module.exports = __webpack_public_path__ + "img/fx_logo.e4e3f01c.jpg";